/*eslint-disable*/
import React from 'react'
import { Link } from 'react-router-dom'

const navigation = {
  solutions: [
    { name: 'Digital Ticketing', href: '/service/bus-ride-service' },
    { name: 'Bus Hiring', href: '/service/hiring' },
    { name: 'Parcel Service', href: '/service/parcel' },
    { name: 'Cargo-truck-service', href: '/service/cargo-truck-service' }
  ],
  support: [
    // { name: 'Downloads', href: '/downloads' },
    { name: 'FAQ', href: '/faq' }
  ],
  company: [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/about' },
    { name: 'Contact', href: '/contact' }
    // { name: 'Careers', href: '/jobs' },
    // { name: 'Partners', href: '/partners' }
  ],
  legal: [
    { name: 'Privacy', href: '/privacy' }
    // { name: 'Terms & Conditions', href: '/terms' }
  ],
  social: [
    {
      name: 'Facebook',
      href: 'https://www.facebook.com/oyaghana/',
      icon: (props) => (
        <img src='/assets/images/footer/facebook.svg' className='h-full' />
      )
    },
    {
      name: 'Twitter',
      href: 'https://twitter.com/oyaghana',
      icon: (props) => (
        <svg fill='currentColor' viewBox='0 0 24 24' {...props}>
          <path d='M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84' />
        </svg>
      )
    },
    {
      name: 'LinkedIn',
      href: 'https://gh.linkedin.com/company/oyaghana',
      icon: (props) => (
        <img src='/assets/images/footer/linkedin.svg' className='h-full' />
      )
    },
    {
      name: 'Instagram',
      href: 'https://www.instagram.com/oyaghana',
      icon: (props) => (
        <img src='/assets/images/footer/Instagram.svg' className='h-full' />
      )
    }
  ]
}

export default function Footer() {
  const nav = navigation.legal.map((item) => (
    <li key={item.name}>
      <a
        href={item.href}
        className='text-base text-gray-500 font-medium hover:text-oya-ghana-light-green'
      >
        {item.name}
      </a>
    </li>
  ))
  return (
    <footer
      className='bg-oya-ghana-green bg-opacity-10 shadow-2xl'
      aria-labelledby='footerHeading'
    >
      <h2 id='footerHeading' className='sr-only'>
        Footer
      </h2>
      <div className='max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8'>
        <div className='md:grid md:grid-cols-2/3 xl:grid-cols-3 sm:gap-4 lg:gap-8'>
          <div className='pr-2 xl:my-0'>
            <Link to='/' className='flex items-center'>
              <img className='h-8 w-auto sm:h-10' src='/logo.png' alt='Oya!' />
              <span className='pl-2 font-bold text-oya-ghana-header-h5'>
                Oya!
              </span>
            </Link>
            <p className='mt-4 text-base text-gray-500 font-medium'>
              Let's go.
            </p>

            {/* <form className="mt-4 sm:flex sm:max-w-md">
              <label htmlFor="emailAddress" className="sr-only">
                Email address
              </label>
              <input
                type="email"
                name="emailAddress"
                id="emailAddress"
                autoComplete="email"
                required
                className="appearance-none min-w-0 w-full bg-white border border-transparent rounded-md py-2 px-4 text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white focus:border-white focus:placeholder-gray-400"
                placeholder="Enter your email"
              />
              <div className="mt-3 rounded-md sm:mt-0 sm:ml-3 sm:flex-shrink-0">
                <button
                  type="submit"
                  className="w-full bg-indigo-500 border border-transparent rounded-md py-2 px-4 flex items-center justify-center text-base font-medium text-white hover:text-oya-ghana-light-green600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-indigo-500"
                >
                  Subscribe
                </button>
              </div>
            </form> */}

            <div className='flex space-x-6 md:order-2 mt-5 pb-4'>
              {navigation.social.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className='text-black font-semibold'
                >
                  <span className='sr-only'>{item.name}</span>
                  <item.icon className='h-6 w-6' aria-hidden='true' />
                </a>
              ))}
            </div>
          </div>

          <div className='grid grid-cols-2 sm:gap-4 md:gap-8 xl:col-span-2 lg:pl-12 xl:pl-16'>
            <div className='md:grid md:grid-cols-2 sm:gap-4 md:gap-8'>
              <div>
                <h3 className='text-oya-ghana-header-h6 font-semibold text-black tracking-wider'>
                  Company
                </h3>
                <ul className='mt-4 space-y-4'>
                  {navigation.company.map((item) => (
                    <li key={item.name}>
                      <a
                        href={item.href}
                        className='text-base text-gray-500 font-medium hover:text-oya-ghana-light-green'
                      >
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className='mt-12 md:mt-0'>
                <h3 className='text-oya-ghana-header-h6 font-semibold text-black tracking-wider'>
                  Support
                </h3>
                <ul className='mt-4 space-y-4'>
                  {navigation.support.map((item) => (
                    <li key={item.name}>
                      <a
                        href={item.href}
                        className='text-base text-gray-500 font-medium hover:text-oya-ghana-light-green'
                      >
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className='md:grid md:grid-cols-2 sm:gap-4 md:gap-8'>
              <div>
                <h3 className='text-oya-ghana-header-h6 font-semibold text-black tracking-wider'>
                  Solutions
                </h3>
                <ul className='mt-4 space-y-4'>
                  {navigation.solutions.map((item) => (
                    <li key={item.name}>
                      <Link
                        to={item.href}
                        className='text-base text-gray-500 font-medium hover:text-oya-ghana-light-green'
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div className='mt-12 md:mt-0'>
                <h3 className='text-oya-ghana-header-h6 font-semibold text-black tracking-wider'>
                  Legal
                </h3>
                <ul className='mt-4 space-y-4'>{nav}</ul>
              </div>
            </div>
          </div>
        </div>
        <div className='pt-8 md:pt-16 md:flex md:items-center md:justify-between'>
          <p className='mt-8 text-base text-black font-semibold md:mt-0 md:order-1'>
            &copy; {new Date().getFullYear()} Kost Konsult. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
